import { formatInTimezone } from '../timezone/utils';
function pick(row, camel, snake) {
    const v = row[camel];
    if (v !== undefined && v !== null)
        return v;
    return row[snake];
}
function toNum(v) {
    if (v === undefined || v === null || v === '')
        return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}
export function creditSignedChange(row) {
    var _a, _b;
    const dir = String((_a = row.direction) !== null && _a !== void 0 ? _a : '').toLowerCase();
    const amt = (_b = toNum(pick(row, 'amount', 'amount'))) !== null && _b !== void 0 ? _b : 0;
    if (dir === 'in')
        return Math.abs(amt);
    if (dir === 'out')
        return -Math.abs(amt);
    return amt;
}
export function creditFlowLabel(row) {
    const d = creditSignedChange(row);
    if (d > 1e-9)
        return 'In';
    if (d < -1e-9)
        return 'Out';
    return 'Neutral';
}
export function formatCreditBalance(v) {
    const n = toNum(v);
    if (n == null)
        return '—';
    return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 });
}
export function formatCreditSignedAmount(row) {
    const d = creditSignedChange(row);
    const abs = Math.abs(d).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 });
    if (d > 1e-9)
        return `+${abs} credits`;
    if (d < -1e-9)
        return `-${abs} credits`;
    return `${abs} credits`;
}
export function creditCreatedAt(row, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    const v = pick(row, 'createdAt', 'created_at');
    if (!v)
        return '—';
    return formatInTimezone(v, timezone);
}
export function creditReferenceLabel(row) {
    const rt = pick(row, 'referenceType', 'reference_type');
    const rid = pick(row, 'referenceId', 'reference_id');
    if (!rt && !rid)
        return '—';
    return `${rt || 'ref'}: ${rid || '—'}`;
}
export function creditField(row, camel, snake) {
    return pick(row, camel, snake);
}
